import React, {useCallback, useEffect, useState} from 'react';
import {confirmable, createConfirmation} from 'react-confirm';
import BasicButton from '../../../../components/BasicButton';
import HorizontalLoader from '../../../../components/HorizontalLoader';
import Popup from '../../../../components/Popup';
import ENDPOINT from '../../../../constants/endpoints';
import UxHelpers from '../../../../helpers/ux-helpers';
import useApi from '../../../../hooks/useApi';

import './styles.css';

const ApplyJobConfirmDialog = props => {
  const {
    show,
    proceed,
    dismiss,
    cancel,
  } = props;

  const api = useApi();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});

  const proceedHandler = useCallback(data => {
    proceed(data);
    UxHelpers.overflowLock('unlock');
  }, [proceed]);

  const cancelHandler = useCallback(() => {
    cancel();
    UxHelpers.overflowLock('unlock');
  }, [cancel]);

  useEffect(() => {
    api.getRequest(ENDPOINT.ENTITY.JOB_SETUP_EMAIL, {id: props.id}, {
      handleSuccess: setData,
      handleError: () => {},
      handleComplete: () => {
        setLoading(false);
      },
    })
  }, []);

  const body = (
    <div className={'apply-job-dialog__body'}>
      {loading && <HorizontalLoader />}
      {!loading && (
        <>
          {!!data.title && (
            <h2 className={'apply-job-dialog__header'}>{data.title}</h2>
          )}
          <div className={'apply-job-dialog__buttons'}>
            <BasicButton
              controlFunc={proceedHandler}
              btnWidth={200}
              btnHeight={40}
              btnFontWeight={500}
              btnArrow={false}
              btnTextColor="#27282d"
              btnText={'Interested in role'}
            />
            <BasicButton
              controlFunc={cancelHandler}
              btnWidth={200}
              btnHeight={40}
              btnFontWeight={500}
              btnArrow={false}
              btnTextColor="#27282d"
              btnText={'Not interested in role'}
            />
          </div>
          {!!data.body && (
            <div className={'apply-job-dialog__content'} dangerouslySetInnerHTML={{__html: data.body}} />
          )}
        </>
      )}
    </div>
  );

  return (
    show && (
      <Popup
        className={'apply-job-dialog'}
        actions={{
          dismiss,
          cancel,
        }}
        bodyRender={body}
        popupStyles={{maxWidth: '480px'}}
        modeless={true}
        dismissWhenClose={true}
        hasCloseButton={false}
      />
    )
  );
};

export default createConfirmation(confirmable(ApplyJobConfirmDialog));
